<app-table [tableService]="workOrderService"></app-table>
